import { Injectable } from '@angular/core';
import { ApiService, Map as StoreMap, ScanZone } from '@ng-cloud/badger-core';
import { RfidScanEvent } from '@ng-cloud/badger-core/models/rfid-scan-event';
import { RfidTag } from '@ng-cloud/badger-core/models/rfid-tag';
import * as _ from 'lodash';
import { from, Observable, of as observableOf } from 'rxjs';

export interface RfidTagListManager {
  getCurrentProduct(): any;

  setCurrentProduct(product: any);

  getRfidScanZones(): ScanZone[];
}

@Injectable({
  providedIn: 'root'
})
export class RfidService extends ApiService {
  rfidTagListManagers = new Map<number, RfidTagListManager>();
  apiName = 'insight';

  static cacheDuration = 600;

  getRfidScanEvents(playExecutionId: number, params?: any): Observable<RfidScanEvent[]> {
    return this.list(RfidScanEvent, `play_executions/${playExecutionId}/rfid_scan_events`, params);
  }

  getRfidScanEvent(rfidScanEventId: number): Observable<RfidScanEvent> {
    return this.get(RfidScanEvent, `rfid_scan_events/${rfidScanEventId}`, RfidService.cacheDuration);
  }

  getRfidScanEventTags(rfidScanEventId: number, params?: any): Observable<RfidTag[]> {
    return this.list(RfidTag, `rfid_scan_events/${rfidScanEventId}/rfid_tags`, params);
  }

  getRfidTags(storeId: number, params?: any): Observable<RfidTag[]> {
    return this.list(RfidTag, `stores/${storeId}/rfid_tags`, params);
  }

  setRfidTagListManager(storeId: number, rfidTagListManager: RfidTagListManager) {
    this.rfidTagListManagers.set(storeId, rfidTagListManager);
  }

  getRfidTagListManager(storeId: number): Observable<RfidTagListManager> {
    return observableOf(this.rfidTagListManagers.get(storeId));
  }

  createTagImage(storeMap: StoreMap, rfidTags: RfidTag[]): Observable<any> {
    const promise = new Promise((resolve) => {
      const image = new Image();

      image.onload = () => {
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = image.width;
        tempCanvas.height = image.height;

        const tempContext = tempCanvas.getContext('2d');

        tempContext.globalAlpha = 1.0;

        _.forEach(rfidTags, tag => {
          const tagLocation = storeMap.pointToPixels({ x: tag.x, y: tag.y });

          tempContext.beginPath();
          tempContext.arc(tagLocation.x, tagLocation.y, 2, 0, Math.PI * 2, true);
          tempContext.closePath();
          tempContext.fillStyle = 'rgba(59, 163, 255, 1.0)';
          tempContext.fill();
        });

        resolve(tempCanvas.toDataURL());
      };

      image.onerror = () => {
        resolve(null);
      };

      image.src = storeMap.getUrl();
    });

    return from(promise);
  }
}
